import { render } from "./ExampleDeviceScreenWeb.vue?vue&type=template&id=5043b4e4&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenWeb.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenWeb.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenWeb.vue?vue&type=style&index=0&id=5043b4e4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5043b4e4"]])

export default __exports__